import React from 'react';
import Button from '../components/Button';
import type { BrandAndProductProps } from '../components/ExternalBrandLogo';
import ExternalBrandLogo from '../components/ExternalBrandLogo';
import useIsLayoutSize from '../post/utils/useIsLayoutSize';
import { LayoutSize } from '../post/utils/useLayoutSize';

interface ExternalBrandButtonProps {
  children: React.ReactNode;
  icon: BrandAndProductProps;
  to: string;
}

const ExternalBrandButton = ({
  children,
  icon,
  to,
}: ExternalBrandButtonProps) => {
  const isMobile = useIsLayoutSize(LayoutSize.mobile);

  return (
    <Button
      icon={<ExternalBrandLogo {...icon} height={16} />}
      size={isMobile ? 'regular' : 'large'}
      to={to}
      variant="secondary"
    >
      {children}
    </Button>
  );
};

export default ExternalBrandButton;
